// src/component/ui/BackToTop.jsx
// Bouton "retour en haut" qui apparaît après avoir défilé.
import React, { useEffect, useState } from "react";
import { FiArrowUp } from "react-icons/fi";
import "./backToTop.css";

export default function BackToTop({ threshold = 400 }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > threshold);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  const toTop = () => {
    const reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" });
  };

  return (
    <button
      type="button"
      className={"back-to-top" + (show ? " is-visible" : "")}
      onClick={toTop}
      aria-label="Retour en haut"
      tabIndex={show ? 0 : -1}
    >
      <FiArrowUp />
    </button>
  );
}
